export type SortableValue = string | number | null;

export class WidgetTableSort<TRow, TColumn extends string> {
    column: TColumn;
    ascending: boolean;

    constructor(
        private readonly getValue: (row: TRow, column: TColumn) => SortableValue,
        defaultColumn: TColumn,
        defaultAscending = true,
    ) {
        this.column = defaultColumn;
        this.ascending = defaultAscending;
    }

    toggle(column: TColumn): void {
        this.ascending = this.column === column ? !this.ascending : true;
        this.column = column;
    }

    apply(rows: TRow[]): TRow[] {
        const direction = this.ascending ? 1 : -1;
        return [...rows].sort((a, b) => {
            const valueA = this.getValue(a, this.column);
            const valueB = this.getValue(b, this.column);
            if (valueA == null && valueB == null) return 0;
            if (valueA == null) return 1;
            if (valueB == null) return -1;
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return (valueA - valueB) * direction;
            }
            return String(valueA).localeCompare(String(valueB)) * direction;
        });
    }
}

export function parseSortColumn<TColumn extends string>(
    value: unknown,
    allowed: readonly TColumn[],
    fallback: TColumn,
): TColumn {
    return typeof value === 'string' && (allowed as readonly string[]).includes(value)
        ? (value as TColumn)
        : fallback;
}
